"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUnifiedicons = require("@bit/gerenciatd.unifiedicons.svg-icon");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var pathMedium = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M22.311,4.515H21.144a4.842,4.842,0,0,0-1-3.273A4.114,4.114,0,0,0,16.968,0H4.176A4.01,4.01,0,0,0,1,1.229,4.678,4.678,0,0,0,0,4.5V10.76a4.842,4.842,0,0,0,1,3.273,4.109,4.109,0,0,0,3.173,1.229H15.927v.125a2.379,2.379,0,0,0,2.659,2.659h3.725a2.374,2.374,0,0,0,2.659-2.659V7.174A2.374,2.374,0,0,0,22.311,4.515ZM15.927,7.174v6.684H4.189a2.684,2.684,0,0,1-2.107-.74,3.47,3.47,0,0,1-.652-2.345V4.5a3.585,3.585,0,0,1,.652-2.345,2.624,2.624,0,0,1,2.107-.74H16.981a2.684,2.684,0,0,1,2.107.74A3.47,3.47,0,0,1,19.74,4.5H18.6A2.419,2.419,0,0,0,15.927,7.174Zm7.638,8.214h0a1.42,1.42,0,0,1-.276.978,1.45,1.45,0,0,1-.978.263H18.586a1.385,1.385,0,0,1-.978-.263,1.385,1.385,0,0,1-.263-.978V7.174c0-.928.314-1.242,1.242-1.242h3.737c.953,0,1.242.288,1.242,1.242v8.214Z",
    fill: "#fff"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M59.347,134.029H53.114a.715.715,0,0,1-.715-.715.7.7,0,0,1,.715-.715h6.233a.715.715,0,0,1,.715.715.7.7,0,0,1-.715.715Z",
    transform: "translate(-45.828 -115.97)",
    fill: "#fff"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M157.472,111.553a.991.991,0,0,1-.251.69.966.966,0,0,1-.69.263.89.89,0,0,1-.69-.263.941.941,0,0,1-.251-.69.9.9,0,0,1,.953-.953A.876.876,0,0,1,157.472,111.553Z",
    transform: "translate(-136.077 -96.729)",
    fill: "#fff"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M78.832,46.3v.79H76.7V46.3h.615V44h-.589v-.74h.1l.426-.05.439-.025a.878.878,0,0,1,.464.1.414.414,0,0,1,.163.376V46.3Z",
    transform: "translate(-67.081 -37.771)",
    fill: "#fff"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M155.655,68.543v.79h-2.508l-.025-.088a.9.9,0,0,1-.025-.213.966.966,0,0,1,.05-.339.991.991,0,0,1,.188-.3l.7-.853a4.866,4.866,0,0,0,.439-.589.627.627,0,0,0,.1-.351.314.314,0,0,0-.1-.251.717.717,0,0,0-.464-.113,4.388,4.388,0,0,0-.677.063l-.15.025v-.8l.1-.025.414-.075a2.883,2.883,0,0,1,.451-.025,1.59,1.59,0,0,1,1.166.376,1.066,1.066,0,0,1,.288.79,1.355,1.355,0,0,1-.188.69,4.139,4.139,0,0,1-.615.8l-.439.477h1.292Z",
    transform: "translate(-133.896 -57.193)",
    fill: "#fff"
  })]
});

var Multipantalla = function Multipantalla(props) {
  var kind = props.kind;
  var path = null;

  switch (kind) {
    default:
      path = pathMedium;
  }

  var viewBox = props.viewBox,
      mainDimension = props.mainDimension;

  if (!viewBox) {
    viewBox = '0 -3.5 25 25';
  }

  if (!mainDimension) {
    mainDimension = 'x';
  }

  var Icon = (0, _gerenciatdUnifiedicons.CreateSvgIcon)(path, "Multipantalla-".concat(kind));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, _objectSpread(_objectSpread({}, props), {}, {
    viewBox: viewBox,
    mainDimension: mainDimension
  }));
};

var _default = Multipantalla;
exports["default"] = _default;

//# sourceMappingURL=index.js.map